// extracted by mini-css-extract-plugin
export default {"header":"Table_header__+D2fX","link":"Table_link__LBsYx","active":"Table_active__Who8r","inactive":"Table_inactive__2AN9e"};